import { MonthlyOrderStatsForStoreDoc } from '@gooduncles/gu-app-schema';
import { AvailableYearForStats } from 'src/constants';
import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getMonthlyOrderStatsForStore } from 'src/utils/firebase/firebase-short-cut';
import { BareFetcher } from 'swr';
import useImmutableSWR from 'swr/immutable';

type options = {
  selectedYears: AvailableYearForStats[];
};

const fetcher: BareFetcher<MonthlyOrderStatsForStoreDoc[]> = ([, options]: [string, options]) => {
  const where: WHERE[] = options.selectedYears ? [['year', 'in', options.selectedYears]] : [];
  return getMonthlyOrderStatsForStore(where);
};

const useMonthlyOrderStatsForStore = (options: options) => {
  const { data: monthlyOrderStatsForStore, isValidating: monthlyOrderStatsForStoreLoading } = useImmutableSWR(
    options.selectedYears.length > 0 ? ['monthlyOrderStatsForStore', options] : null,
    fetcher
  );
  return {
    monthlyOrderStatsForStore,
    monthlyOrderStatsForStoreLoading,
  };
};

export default useMonthlyOrderStatsForStore;
